import request from "../request";

export const getWorktimesApi = async (versionID: number | string, email: string): Promise<API.Worktime.ListResult> => {
    let url = `/workbenchApi/worktimes?versionID=${versionID}`
    
    if (email) {
        url += `&email=${email}`
    }
    return await request.get(url);
};

export const getUserWorktimesApi = async (memberID: number | string, email: string): Promise<API.Worktime.UserWorktimeResult> => {
    let url = `/workbenchApi/worktimes/members/${memberID}`
    if (email) {
        url += `?email=${email}`
    }
    return await request.get(url);
};
export const getWorktimeMembersApi = async (memberID: number | string, email: string): Promise<API.Worktime.MemberTime[]> => {
    let url = `/workbenchApi/worktimes/members/${memberID}/members`
    if (email) {
        url += `?email=${email}`
    }
    return await request.get(url);
};
export const updateMemberWorktimeApi = async (memberID: number | string, data: { worktimeTimeEntries: Partial<API.Worktime.UserWorktimeEntry>[] }): Promise<{}> => {
    let url = `/workbenchApi/worktimes/members/${memberID}/worktimeTimeEntries`
    return await request.post(url, data);
};
export const getWorktimeHistorysApi = async (params: any): Promise<API.ListData<API.Worktime.Version>> => {
    let url = `/workbenchApi/worktimes/histories`
    return await request.get(url, {
        params: params
    });
};
export const approvalWorktimeApi = async (id: number): Promise<{}> => {
    let url = `/workbenchApi/worktimes/${id}/audit-timeworks`
    return await request.post(url);
};
// 主创工时审批列表
export const getLeadWorktimeHistorysApi = async (params: any): Promise<API.ListData<API.LeadWorktime.HistoryItem>> => {
    let url = `/workbenchApi/worktimes/pa-histories`
    return await request.get(url, {
        params: params
    });
};
// 获取主创单条审批详情
export const getLeadWorktimeItemApi = async (params: Request.LeadWorktimeItem): Promise<API.LeadWorktime.Version> => {
    let url = `/workbenchApi/worktimes/pa-versions`
    return await request.get(url, {
        params: params
    });
};
// 主创审批
export const approvalLeadWorktimeApi = async (date: string): Promise<{}> => {
    let url = `/workbenchApi/worktimes/pa-versions/${date}/audit-timeworks`
    return await request.post(url);
};
// 获取指定用户的预估工时数据
export const getEstimateWorktimesApi = async (params: {endDate?: string; opUserID?:  number; startDate?: string, type: string}): Promise<API.Worktime.EstimateWorktime[]> => {
    let url = `/workbenchApi/worktime-daily/estimate-projects`
    return await request.get(url, {
        params: params
    });
};
